import axios from 'axios';
import TomSelect from 'tom-select';

declare let booking_object: any;

export default class getArena{ 

    /**
     * Get time slot
     * @returns 
     */
    get(
        el_arena: string,
        el_rooms: string,
    ){ 
        
        const _that = this;

        // Element room
        const elRoom = document.querySelector(el_rooms) as HTMLSelectElement | null;

        const settings: any = {
            plugins: ['dropdown_input'],
            valueField: 'id',
            labelField: 'name',
            searchField: 'name',
            preload: true,
            load: function (query, callback) {

                const q = {
                    'name' : query
                }
                
                // Post data
                const post_data = {
                    'room_id': (elRoom !== null) ? elRoom.value : '',
                };
            
                // Query string
                const queryString = new URLSearchParams(post_data).toString();
    
                // Call ajax
                axios.post(booking_object.rest_urls.admin_get_arena, queryString)
                .then(function (response: any) {
    
                    callback(response.data);

                })
                .catch(function (error: any){
    
                    console.log(error);
    
                });
            },
            render: {
                option: function (item, escape) {
                    return '<span class="block w-full fluid-text-xs">'+ escape(item.name) +'</span>';
                },
                item: function (item, escape) {
                    return '<span>'+ escape(item.name) +'</span>';
                },
            }
        };

        const control: TomSelect = new TomSelect(el_arena, settings);
        
        if(elRoom !== null){
            
            const val_room = elRoom.value;
            
            if(val_room.length === 0){
            
                control.disable();
                
            }

        }

        elRoom?.addEventListener('change', function(e){
            
            e.preventDefault();

            _that.changeRoomTimeSlotSelect(
                control,
                elRoom.value
            );

        });
        
        return control;
        
    }

    /**
     * Change time slot
     * @param elRoom 
     * @param control 
     */
    changeRoomTimeSlotSelect(
        control: TomSelect,
        val_room: string,
    ){

        if(val_room.length !== 0){
            
            control.clear();
            control.clearOptions();

            // Post data
            const post_data = {
                'room_id': val_room,
            };
        
            // Query string
            const queryString = new URLSearchParams(post_data).toString();
    
            // Call ajax
            axios.post(booking_object.rest_urls.admin_get_arena, queryString)
            .then(function (response: any) {

                const data = response.data.data;

                const isObjectEmpty = (objectName) => {
                    return Object.keys(objectName).length === 0
                }

                if(typeof data === 'object' && data !== null){
                            
                    // Checking if the object is not empty
                    if(!isObjectEmpty(data)){

                        control.enable();
                        control.addOptions(data, false);
                        control.setValue([data[0].id]);

                    }

                }else{
                    
                    // Case in which the data is neither an object nor a string
                    control.setValue('');
                    control.disable();

                }

            })
            .catch(function (error: any){
    
                console.log(error);
    
            });

        }else{

            return;

        }
        
    }

}